const baseUrl = document.body.getAttribute("data-site-domain") || undefined;

export function resolveUrl(url: string): string {
  try {
    return new URL(url, baseUrl).toString();
  } catch {
    return url;
  }
}
